module.exports = __webpack_public_path__ + "img/eu.5e7fb484.png";